export default __webpack_public_path__ + "static/media/slider-software-slide-02.92ef55ee.png";